import { COLLEEN_VENDOR } from 'portal-modules/common/constants/keys'
import { getEmbeddedVendorName } from 'portal-modules/common/utils/get-embedded-vendor-name'

export default () => ({
  isColleenPayment: window?.rpSettings?.loginFromExternalSource || getEmbeddedVendorName() === COLLEEN_VENDOR || false,
})